$(document).ready(function() {
    if (typeof window.AffiliateGrid !== 'undefined') {
        $('#affiliates-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: window.getKendoGridFilterableSettings(),
            pageable: true,
            columns: [
                {
                    field: 'TitleFormatted',
                    title: 'Title',
                    width: '150px'
                },
                {
                    title: 'Potential Rewards',
                    template:
                        '$#=data.CalculateBaseCommission#' +
                        '# if(data.calculateBalloonBonus > 0) { #' +
                        "<span class='bonus'>$#=data.calculateBalloonBonus# Bonus</span>" +
                        '# } #',
                    width: '230px'
                },
                {
                    title: 'Total Rewards to Date',
                    template:
                        '$#=data.TotalCalculatedNonBonusCommission#' +
                        '# if (data.getBonusCommissionAmount > 0) { #' +
                        "<span class='bonus'>$#=data.getBonusCommissionAmount# Bonus</span>" +
                        '# } #',
                    width: '230px'
                },
                {
                    field: 'getApplicableApprovedCustomersCount',
                    title: 'Successful Leads',
                    filterable: false,
                    width: '200px'
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template:
                        "# if(data.Status == 'enabled') { #" +
                        "<span class='status-enabled status'>Enabled</span>" +
                        "# } else if(data.Status == 'disabled') { #" +
                        "<span class='status-disabled status'>Disabled</span>" +
                        "# } else if(data.Status == 'commission-change-pending') { #" +
                        "<span class='status-commission-pending status'>Reward Change Pending</span>" +
                        "# } else if(data.Status == 'pending') { #" +
                        "<span class='status-pending status'>Pending</span>" +
                        '# } #',
                    width: '300px'
                },
                {
                    filterable: false,
                    title: '',
                    template:
                        '<a href="/affiliate/editdetails/${TotemAffiliateStaffID}/${ID}/0" id="edit-details-${ ID }" data-record-id="${ ID }" class="edit-btn">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.5 21l-6.5 2 2-6.5 12-12 4.5 4.5zM15 4.5l3.086-3.085c.' +
                        '778-.778 2.05-.778 2.828 0l1.672 1.671c.778.779.778 2.051 0 2.829l-3.086 3.085M17.25 6.75l-10.75 10.75M3 16.5l1 1h2.5v2.5l1 1M2 20l2 2M16.5 3l4.5 4.5" ' +
                        'stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></svg></a>',
                    width: '125px'
                }
            ],
            dataSource: window.AffiliateGrid,
            pageable: {
                pageSize: 10
            },
            filterMenuInit: function(filterElement) {
                var textFields = ['TitleFormatted'];
                window.initializeTextFilterForKendoGrid(filterElement, textFields);
            }
        });
    }

    $('#DisabledStatusFilter')
        .on('change', function() {
            var grid = $('#affiliates-grid').data('kendoGrid');

            var filter = grid.dataSource.filter();
            var arrayFilter = [];
            if (typeof filter !== 'undefined') {
                // remove the previous filter
                filter.filters = $.grep(
                    filter.filters,
                    function(f) {
                        return f.field === 'Status';
                    },
                    true
                );
                arrayFilter = arrayFilter.concat(filter.filters);
            }

            if ($(this).is(':checked')) {
                arrayFilter.push({
                    field: 'Status',
                    operator: 'eq',
                    value: 'disabled'
                });
            } else {
                arrayFilter.push({
                    field: 'Status',
                    operator: 'neq',
                    value: 'disabled'
                });
            }

            grid.dataSource.filter(arrayFilter);
        })
        .trigger('change');
});
